import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import { deleteAccountTaxCodeAsync, getAccountTaxCodeByAccountTaxCodeIdAsync, checkedAllState, unCheckedAllState, checkedState, unCheckedState, updateAccountTaxCodeAsync,updateSorting } from './taxcodeSlice';
import clsx from 'clsx';
import { ShowToast } from '../../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { setItemStatus, getValueFromResource, FormatInvoiceDecimalNumber} from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const TaxCodeItem = (props: any) => {
    const { taxcodelist, t, onopenModal, IsEdit, IsDelete } = props;
    console.log('taxcodelist',taxcodelist)
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.taxcode);
    
        const { maxMenuHeight, cultureInfoName, decimalPlaces } = useAppSelector(state => state.globalState);
    const dispatch = useAppDispatch();
    const onDeleteClick = (AccountTaxCodeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountTaxCodeAsync(AccountTaxCodeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Tax Code Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {

                        })
                }
            })
            .catch((error) => {

            });

    }
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountTaxCodeId: number) => {
        dispatch(getAccountTaxCodeByAccountTaxCodeIdAsync(AccountTaxCodeId))
            .unwrap()
            .then((originalPromiseResult) => {
                // modelRef.current.click();
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const handleIsDisabledChange = (e: any, taxcodeDetail: any) => {
        const { checked } = e.target;
        const foundIndex = taxcodelist.findIndex((item: any) => item.AccountTaxCodeId === taxcodeDetail.AccountTaxCodeId);
        if (foundIndex !== -1) {
            const foundItem = taxcodelist[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...taxcodelist.slice(0, foundIndex), updatedItem, ...taxcodelist.slice(foundIndex + 1)];
            dispatch(updateAccountTaxCodeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                    ShowToast("Tax Code Updated Successfully", 'Success', "success", "toast-top-right") :
                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>
          
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    <th style={{ width: '15%' }}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                            {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-50'>
                            {/* {t('Tax Code')} */}
                            {getValueFromResource('Tax Code',dispatch, t)}
                        {sortColumn === 'TaxCode' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "TaxCode") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "TaxCode") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "TaxCode") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "TaxCode") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-25'>
                            {/* {t('Formula')} */}
                            {getValueFromResource('Formula',dispatch, t)}
                        {sortColumn === 'Formula' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Formula") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Formula") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Formula") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Formula") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {taxcodelist.length > 0 && taxcodelist.map((taxcodeDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(taxcodeDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {taxcodeDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(taxcodeDetail.AccountTaxCodeId) : undefined}
                            >
                                <span className="d-block">{taxcodeDetail.TaxCode}</span>
                            </td>

                            <td>
                            <span className="d-block">
                               {/*  {taxcodeDetail.Formula.replace(
                                    /(\d+(\.\d+)?)/, 
                                    (match: any) => FormatInvoiceDecimalNumber(cultureInfoName.toString(), parseFloat(match), decimalPlaces)
                                )}
                                    */}
                                    {taxcodeDetail.Formula.replace(
                                        /(\d+(?:\.\d+)?)/g,
                                        (match: string) =>
                                            FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(match),match.includes(".") ? match.split(".")[1].length : 0
                                            )
                                    )}
                                
                            </span>
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                         <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={taxcodeDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, taxcodeDetail) }}
                                        /> 
                                       
                                    </div>
                                </td>
                            } */}
                             <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => onEditClick(taxcodeDetail.AccountTaxCodeId)}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            {IsDelete && IsEdit && (taxcodeDetail.MasterTaxCodeId === null || taxcodeDetail.MasterTaxCodeId === 0) &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete && (taxcodeDetail.MasterTaxCodeId === null || taxcodeDetail.MasterTaxCodeId === 0) &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(taxcodeDetail.AccountTaxCodeId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
                                   {taxcodelist.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }

        </>

    )
}

export default TaxCodeItem;
